module.exports = __webpack_public_path__ + "img/chinesecompany130.6c18346a.png";